var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeppelinChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    enableBackground: "new 0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.064,15.398c0,0.094-0.035,0.176-0.105,0.246s-0.152,0.105-0.246,0.105L0.928,15.785c-0.141,0-0.258-0.082-0.352-0.246 c-0.07-0.141-0.047-0.281,0.07-0.422l2.145-2.355V4.958c0-0.539,0.193-0.996,0.58-1.371c0.387-0.375,0.85-0.562,1.389-0.562h10.371 c0.539,0,0.996,0.188,1.371,0.562c0.375,0.375,0.562,0.832,0.562,1.371V15.398z M16.326,15.012V4.958 c0-0.328-0.117-0.609-0.352-0.844c-0.234-0.234-0.516-0.352-0.844-0.352H4.76c-0.328,0-0.609,0.118-0.844,0.352 C3.682,4.348,3.564,4.629,3.564,4.958v7.98c0,0.094-0.035,0.176-0.105,0.246l-1.688,1.828H16.326z M6.061,9.738h1.582V9H6.061 V9.738z M9.225,9.738h1.547V9H9.225V9.738z M12.354,9.738h1.582V9h-1.582V9.738z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeppelinChatIcon);
export default __webpack_public_path__ + "static/media/zeppelin-chat-icon.daa9a632.svg";
export { ForwardRef as ReactComponent };